import React, { useContext, useEffect } from "react";
import { AuthContext } from "../../utils/auth-provider.js";
import { analytics } from '../../utils/firebase.js'
import { logEvent } from "@firebase/analytics";
import Loading from '../loading.js';
import AuthBox from '../auth-box.js';
import { useLayoutContext } from "../../contexts/LayoutContext.js";

export default function Login() {
    const { setLayoutProps } = useLayoutContext();
    useEffect(() => {
        setLayoutProps(null);
    }, [setLayoutProps]);
    
    return (
        <AuthBox version="login" />
    )
}
